import { v4 as uuidv4, validate as uuidValidate } from 'uuid';
import { UUID } from '../types';

/**
 * Generate a new UUID
 */
export const generateUUID = (): UUID => {
  return uuidv4() as UUID;
};

/**
 * Validate if a string is a valid UUID
 */
export const isValidUUID = (id: string): boolean => {
  return uuidValidate(id);
};

/**
 * Convert a string to UUID type (with validation)
 */
export const toUUID = (id: string): UUID => {
  if (!isValidUUID(id)) {
    throw new Error(`Invalid UUID format: ${id}`);
  }
  return id as UUID;
};

/**
 * Safely convert a string to UUID type (without throwing)
 */
export const safeToUUID = (id: string): UUID => {
  // For backwards compatibility with existing data that might not be proper UUIDs
  // In a real app, you'd want to migrate existing data to proper UUIDs
  return id as UUID;
};

/**
 * Check if two UUIDs are equal
 */
export const uuidsEqual = (uuid1: UUID, uuid2: UUID): boolean => {
  return uuid1 === uuid2;
};